/**
 * What the customer pages share on top of pageStyles: a narrower column, and prose instead of
 * code in the text areas (a persona is written, not configured).
 */
import { css } from 'lit';

import { touchOrNarrow } from '../media.js';

export const customerStyles = css`
  :host {
    max-width: var(--customer-width);
    margin: 0 auto;
  }

  textarea.prose {
    font-family: inherit;
    font-size: var(--font-size-ui);
  }

  /* No zoom on focus in Safari on iOS (formStyles). */
  @media ${touchOrNarrow} {
    textarea.prose {
      font-size: var(--font-size-touch-field);
    }
  }

  .card + .card {
    margin-top: var(--space-4);
  }

  .card h2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
  }

  .excerpt {
    margin: 0;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: var(--text-muted);
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-3);
    margin-top: var(--space-5);
  }
`;
